export const APP_KEY = 'app';

export const LOAD_APP = `mlb/${APP_KEY}/LOAD_APP`;
export const CLIENT_SIDE_READY = `mlb/${APP_KEY}/CLIENT_SIDE_READY`;
